import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../styles/bootstrap.min.css';
import '../styles/style.css';
import MainSidebar from '../components/MainSidebar'; // Keep the sidebar
import rightarrow from '../assets/images/right.svg';
import config from '../config/config';

const GoogleAccount = () => {
  const [email, setEmail] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/Login');
      return;
    }

    // Fetch current user details API
    const fetchUserDetails = async () => {
      try {
        const response = await axios.get('https://bvmwebsolutions.com/patreon-pass/backend/api/current-user-details', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.data.success) {
          const userEmail = response.data.data.user.email;
          setEmail(userEmail); // Set the email from the response
        } else {
          setErrorMessage('Error fetching user details');
        }
      } catch (error) {
        setErrorMessage('Error fetching user details');
        console.error('Error fetching user details', error);
      }
    };

    fetchUserDetails();
  }, [navigate]);

  const handleBackClick = () => {
    navigate(-1); // Go back to the previous page
  };

  return (
    <div className="main_patreonpass_wrapper">
      <div className="patreonpass_container">
        <div className="left_sidebar">
          <MainSidebar /> {/* Keep the sidebar */}
        </div>
        <div className="patreonpass_main_content edit_profile_settings" id="content">
          <div className="left_main_content">
            <div className="feed_wrapper">
              <div className="page_title_with_dropdown notification_page">
                <div className="page_heading">
                  <button className="profile_back_btn" onClick={handleBackClick}>
                    <svg width={54} height={54} viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M48 27.5363L5.99998 27.5363M5.99998 27.5363L27 49.0532M5.99998 27.5363L27 6.3032" stroke="#222" strokeWidth={6} strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </button>
                  <h1>Linked accounts</h1> {/* Updated title */}
                </div>
              </div>
              <div className="menus_all_wrapper">
                <div className="edit_settings_menu_list">
                  <ul>
                    <li><a href="/editprofile">Profile <span className="menu_arrow"><img src={rightarrow} alt="" /></span></a></li>
                    <li><a className='active_profile_menu' href="/accountsettings">Account <span className="menu_arrow"><img src={rightarrow} alt="" /></span></a></li>
                    <li><a href="/privacy">Privacy and Safety <span className="menu_arrow"><img src={rightarrow} alt="" /></span></a></li>
                    <li><a href="/notificationsettings">Notifications <span className="menu_arrow"><img src={rightarrow} alt="" /></span></a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="right_main_content">
            <div className="linked_accounts">
              <div className="page_title_with_dropdown notification_page">
                <div className="page_heading">
                  <h1>Google Account</h1> {/* Updated title */}
                </div>
              </div>

              <div className="edit_profile_fields with_top_fixed_heading">
                <div className="fields_menu_bottom_box_edit_account edit_username_fields">
                  <div className="editable_fields_user edit_username_field">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="mb-4 position_relative">
                          <div className="b-field-like">
                            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                              <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" />
                              <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" />
                              <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" />
                              <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" />
                              <path d="M1 1h22v22H1z" fill="none" />
                            </svg>
                            <span className="g-blue">{email}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="divider_line" />
                  </div>
                </div>
              </div>

              {/* Display any messages if they exist */}
              {errorMessage && (
                <div className="text-danger">
                  {errorMessage}
                </div>
              )}
              {successMessage && (
                <div className="text-success">
                  {successMessage}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GoogleAccount;  {/* Export the updated component */}
